module.exports = function() {
  return new Worker(__webpack_public_path__ + "ee9e0f29efce1e4b35e2.worker.js");
};